import React, { useState } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import useInterval from '@hooks/useInterval';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
  p {
    line-height: 1;
  }
`;

type Props = {};
function TextColck({}: Props) {
  const [now, setNow] = useState(new Date());
  useInterval(() => {
    // 1분마다 업데이트
    setNow(new Date());
  }, 60000);

  return (
    <Wrapper>
      <h4>{dayjs(now).format('h:mm A')}</h4>
      <p>{dayjs(now).format('YYYY-MM-DD ddd')}</p>
    </Wrapper>
  );
}

export default TextColck;
